<div class="container" [ngClass]="'blocksgroup-'+ code">
  <div>
    <h1 *ngIf="blocksGroup.title">{{ blocksGroup.title }}</h1>

    <app-blocks *ngIf="hasBlocks" [blocks]="blocksGroup.blocks">
    </app-blocks>
  </div>
</div>
